"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.384 4.895a.7.7 0 0 1 .854.501L5.98 8.26h2.346l.503-2.22c.282-1.245 2.058-1.245 2.34 0l.503 2.22h2.346l.743-2.863a.7.7 0 0 1 1.356.352l-.653 2.51H16.8a.7.7 0 1 1 0 1.4h-1.698l-.233.897H16.8a.7.7 0 1 1 0 1.4h-2.295l-.59 2.274c-.317 1.218-2.054 1.19-2.332-.036l-.508-2.238h-2.15l-.508 2.238c-.278 1.226-2.015 1.254-2.332.036l-.59-2.274H3.2a.7.7 0 1 1 0-1.4h1.931l-.233-.896H3.2a.7.7 0 1 1 0-1.4h1.335l-.652-2.51a.7.7 0 0 1 .501-.854m1.96 4.764.233.896h1.23l.202-.896zm3.101 0-.203.896h1.516l-.203-.896zm.793-1.4L10 7.21l-.238 1.049zm1.753 1.4.203.896h1.229l.232-.896zm1.068 2.296h-.548l.255 1.126zm-5.57 0h-.548l.293 1.126z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencySouthKoreanWonIcon20.js.map